import { testimonialTypes } from '../../types'

class TestimonialVideo {
  excerpt: string

  metaReviewerName: string

  metaReviewerVideo: string

  featuredImage: {
    node: {
      localFile: {
        childImageSharp: {
          gatsbyImageData: object
        }
      }
    }
  }

  constructor(testimonialVideo: testimonialTypes.TestimonialVideo) {
    this.excerpt = testimonialVideo.excerpt
    this.metaReviewerName = testimonialVideo.metaReviewerName
    this.metaReviewerVideo = testimonialVideo.metaReviewerVideo
    this.featuredImage = testimonialVideo.featuredImage
  }
}

export default TestimonialVideo
